let upsellOptionWant = null;
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if( document.querySelector('.this__upsell_swiperWrapper') ){
      if( document.querySelector('.this__upsell_swiperWrapper').childElementCount == 0 ){ document.querySelector('.items__blocks__content.items__upsell_blocks').classList.add('hidden'); }
    }
    if ( this.querySelectorAll('.cart_empty_items_swiper.swiper').length > 0 ){
      this.swiperElementCardSwp = this.querySelector('.cart_empty_items_swiper.swiper');
      if (this.swiperElementCardSwp) {
        this.config = { spaceBetween: 18,allowTouchMove: true,slidesPerView: 'auto',grabCursor: true,keyboard: { enabled: true } };
        if (!this.isIOS) {
          this.config.freeMode = true;
          this.config.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
        }
        new Swiper(this.swiperElementCardSwp, this.config);
      }  
    }
    if ( this.querySelectorAll('.this__upsell_swiper.swiper').length > 0 ){
      this.swiperElementUpsellSwp = this.querySelector('.this__upsell_swiper.swiper');
      if (this.swiperElementUpsellSwp) {
        this.configUpsell = { spaceBetween: 12,allowTouchMove: true,slidesPerView: 'auto',grabCursor: true,keyboard: { enabled: true } };
        if (!this.isIOS) {
          this.configUpsell.freeMode = true;
          this.configUpsell.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
        }
        new Swiper(this.swiperElementUpsellSwp, this.configUpsell);
      }  
    }

    if ( this.querySelectorAll('.quantity_child__summary').length > 0 ){
      this.querySelectorAll('.quantity_child__summary').forEach((el)=>{
        el.addEventListener('click',(tg)=>{
          tg.preventDefault();
          let bundleParentId = tg.target.closest('.optimize-bundle-parent-card').getAttribute(`data-fake-bundle-id`);
          tg.target.closest('.optimize-bundle-parent-card').querySelector(`.quantity_child__summary`).classList.toggle(`active`);
          let bundleParentChildsScrollHgt = document.querySelector(`.child___products_w__parent[data-fake-bundle-id-childs="${bundleParentId}"]`).scrollHeight;
          if( tg.target.closest('.optimize-bundle-parent-card').querySelector(`.quantity_child__summary`).classList.contains('active') ){
            document.querySelector(`.child___products_w__parent[data-fake-bundle-id-childs="${bundleParentId}"]`).style.maxHeight = `${bundleParentChildsScrollHgt}px`;
          }else{
            document.querySelector(`.child___products_w__parent[data-fake-bundle-id-childs="${bundleParentId}"]`).style.maxHeight = null;
          }
        })
      })
    }

    if( this.querySelectorAll('[js-upgrade-item]').length > 0 ){
      this.querySelectorAll('[js-upgrade-item]').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          this.enableLoading();
           let id_upgrade,id_qtySt,id_sell_id,id_key_url,id_updateProduct;
           id_upgrade = target.target.getAttribute('data-upgrade-variant-id');
           id_qtySt = target.target.getAttribute('upgrade-data-qty');
           id_sell_id = target.target.getAttribute('data-upgrade-selling-id');
           id_key_url = target.target.getAttribute('upgrade-data-line');
           id_updateProduct = {'items': [{'id': id_upgrade,'quantity': id_qtySt,'selling_plan':id_sell_id}]};
          fetch(id_key_url, {
            method: 'GET',
          }).then(response => {
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {'Content-Type': 'application/json'},
              body: JSON.stringify(id_updateProduct)
            }).then((response) => response.text())
            .then((responseText) => {
                fetch(`${routes.cart_url}?section_id=cart-drawer`)
                .then((response) => response.text())
                .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html'); const sourceQty = html.querySelector('#cart-drawer__inner'); document.querySelector('#cart-drawer__inner').innerHTML = sourceQty.innerHTML;
                });
                fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
                .then((response) => response.text())
                .then((responseText) => {
                  const bubble_html = new DOMParser().parseFromString(responseText, 'text/html'); const bubble_sourceQty = bubble_html.querySelector('.cart-count-bubble'); document.querySelector('.cart-count-bubble').innerHTML = bubble_sourceQty.innerHTML;
                });
            }).finally(() =>{ this.disableLoading() }).catch((e) => { console.error(e); });
          }).catch((error) => { console.error('Error:', error); });
        })
      })
    }

    if (this.querySelectorAll('[js-upgrade-bundle-item]').length > 0) {
      this.querySelectorAll('[js-upgrade-bundle-item]').forEach((elm) => {
        elm.addEventListener('click', async (event) => {
          event.preventDefault();
          const cartDrawer = this.closest('cart-drawer');
          const uniqBundleId = elm.getAttribute('data-uniq-bundle-id');
          if (!uniqBundleId || !cartDrawer) return;
          try {
            if (typeof cartDrawer.enableLoading === 'function') cartDrawer.enableLoading();
            const res = await fetch(window.Shopify.routes.root + 'cart.js');
            const cart = await res.json();
            const itemsToUpdate = cart.items.filter(item => 
              item.properties && 
              item.properties._uniqBundleId === uniqBundleId && 
              item.properties._selling_plan_id
            );

            if (itemsToUpdate.length > 0) {
              for (const item of itemsToUpdate) {
                const dynamicSellingPlanId = item.properties._selling_plan_id;
                const updatedProperties = { ...item.properties, _is_onetime: "false" };
                const changeResponse = await fetch(window.Shopify.routes.root + 'cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    id: item.key,
                    quantity: item.quantity,
                    selling_plan: parseInt(dynamicSellingPlanId, 10),
                    properties: updatedProperties
                  })
                });
                await changeResponse.json();
              }
            } else {
              console.warn("No matching bundle items with _selling_plan_id found.");
            }

            if (typeof cartDrawer.getSectionsToRender === 'function') {
              const sections = cartDrawer.getSectionsToRender();
              for (const section of sections) {
                const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
                if (!elementToReplace) continue;
                const response = await fetch(`${window.location.pathname}?sections=${section.section}`);
                const parsedState = await response.json();
                elementToReplace.innerHTML = new DOMParser()
                  .parseFromString(parsedState[section.section], 'text/html')
                  .querySelector(section.selector).innerHTML;
              }
            } else {
              window.location.reload();
            }
          } catch (err) {
            console.error("Bundle Upgrade Error via Change API:", err);
          } finally {
            if (typeof cartDrawer.disableLoading === 'function') cartDrawer.disableLoading();
          }
        });
      });
    }

    if (this.querySelectorAll('[js-upgrade-bundle-item-group]').length > 0) {
      this.querySelectorAll('[js-upgrade-bundle-item-group]').forEach((elm) => {
        elm.addEventListener('click', async (event) => {
          event.preventDefault();
          const cartDrawer = this.closest('cart-drawer');
          const targetBundleId = event.currentTarget.getAttribute('data-uniq-bundle-id');
          if (!targetBundleId || !cartDrawer) return;
          try {
            if (typeof cartDrawer.enableLoading === 'function') cartDrawer.enableLoading();
            const res = await fetch(window.Shopify.routes.root + 'cart.js');
            const cart = await res.json();
            const itemsToUpdate = cart.items.filter(item => 
              item.properties && 
              item.properties._uniq_id_lookup === targetBundleId && 
              item.properties._selling_plan_id
            );
            for (const item of itemsToUpdate) {
              const dynamicSellingPlanId = item.properties._selling_plan_id;
              const updatedProperties = { 
                ...item.properties, 
                _is_onetime: "false" 
              };
              const changeRes = await fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: item.key,
                  quantity: item.quantity,
                  selling_plan: parseInt(dynamicSellingPlanId, 10),
                  properties: updatedProperties
                })
              });
              await changeRes.json(); 
            }
            if (typeof cartDrawer.getSectionsToRender === 'function') {
              const sections = cartDrawer.getSectionsToRender();
              for (const section of sections) {
                const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
                if (!elementToReplace) continue;
                const response = await fetch(`${window.location.pathname}?sections=${section.section}`);
                const parsedState = await response.json();
                elementToReplace.innerHTML = new DOMParser()
                  .parseFromString(parsedState[section.section], 'text/html')
                  .querySelector(section.selector).innerHTML;
              }
            } else {
              window.location.reload();
            }
          } catch (err) {
            console.error("Bundle Group Upgrade Error:", err);
          } finally {
            if (typeof cartDrawer.disableLoading === 'function') cartDrawer.disableLoading();
          }
        });
      });
    }

    if( this.querySelectorAll('[js-upsell-add-cart]').length > 0 ){
      this.querySelectorAll('[js-upsell-add-cart]').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          this.enableLoading();
          let u_id,u_updateProduct;
           u_id = target.target.getAttribute('data-upsell-id');
           u_updateProduct = {'items': [{'id': u_id,'quantity': 1}]};
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(u_updateProduct)
          }).then((response) => response.text())
          .then((responseText) => {
             fetch(`${routes.cart_url}?section_id=cart-drawer`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html'); const sourceQty = html.querySelector('#cart-drawer__inner'); document.querySelector('#cart-drawer__inner').innerHTML = sourceQty.innerHTML;
              });
             fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
              .then((response) => response.text())
              .then((responseText) => {
                const bubble_html = new DOMParser().parseFromString(responseText, 'text/html'); const bubble_sourceQty = bubble_html.querySelector('.cart-count-bubble'); document.querySelector('.cart-count-bubble').innerHTML = bubble_sourceQty.innerHTML;
              });
          }).finally(() =>{ this.disableLoading() }).catch((e) => { console.error(e); });          
        })
      })
    }
    if (isValidSession) {this.querySelector('[js-welcome-offer-bar]').classList.remove('hidden')}
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    document.querySelector('.cart_drawer_main_wrapper').classList.add('active');
    document.querySelector('.page-overlay').classList.add('is-visible');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    document.querySelector('.cart_drawer_main_wrapper').classList.remove('active');
    document.querySelector('.page-overlay').classList.remove('is-visible');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__inner',
        section: document.getElementById('cart-drawer__inner').dataset.id,
        selector: '#cart-drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: document.getElementById('cart-icon-bubble').dataset.id,
        selector: '.cart-icon-bubble'
      }
    ];
  }  

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.open();
      if( document.querySelector('.this__upsell_swiperWrapper') ){
        if( document.querySelector('.this__upsell_swiperWrapper').childElementCount == 0 ){ document.querySelector('.items__blocks__content.items__upsell_blocks').classList.add('hidden'); }
      }
    });
  }
  
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }  

  updateQuantity(line, quantity, name, updateData = null, action = null, itemData = null) {
    this.enableLoading(line);
    if (action === 'bundle' && updateData != null) {
      const splitData = updateData.split('==');
      const childKeys = splitData[0].split(',');
      const parentData = splitData[1].split('|');
      const jsonItemData = JSON.parse(itemData || '{}');
      let updates = {};
      childKeys.forEach(key => {
        const data = key.split('|');
        updates[data[0]] = parseInt(data[1]) * quantity;
      });
      updates[parentData[0]] = parseInt(quantity);
      let properties = jsonItemData.properties || {};
      if (quantity > 0) {
        childKeys.forEach((key, index) => {
          const data = key.split('|');
          properties[`Product_${index + 1}`] = `${data[2]} | ${parseInt(data[1]) * quantity}`;
        });
      }
      this.bundleUpdateAction(updates);
    } else {
      let body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((s) => s.section),
        sections_url: window.location.pathname
      });
      this.fetchAction(routes.cart_change_url, body);
    }
  }  

  onChange(event) {
    if(event.target.value !== 'on') {
      if(event.target.closest('[data-bundle-items]')){
        this.updateQuantity(
          event.target.dataset.index,
          event.target.value,
          document.activeElement.getAttribute('name'),
          event.target.closest('[data-bundle-items]').dataset.bundleItems,
          'bundle',
          event.target.closest('[data-bundle-items]').querySelector('.item-data').innerText
        );
      }else{
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
      }
    }
  }  
  
  async bundleUpdateAction(updates) {
    const payload = JSON.stringify({
      updates: updates,
      sections: this.getSectionsToRender().map((s) => s.section),
      sections_url: window.location.pathname
    });
    this.fetchAction(routes.cart_update_url, payload);
  }

  fetchAction(fetchUrl,body){
    fetch(`${fetchUrl}`, {...fetchConfig(), ...{ body }})
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      this.getSectionsToRender().forEach((section => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          
        elementToReplace.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
  
      }));
      this.disableLoading();  
    }).catch(() => {
      this.disableLoading();
    }).finally(() => {
      
    });
  }

  enableLoading() {
    if (!!document.getElementById('cart-drawer-loading')) {
     document.getElementById('cart-drawer-loading').classList.remove('hidden');
    }  
  } 
  
  disableLoading() {
    if (!!document.getElementById('cart-drawer-loading')) {
     document.getElementById('cart-drawer-loading').classList.add('hidden');
    }
  }  
  
  removeAll() {
    const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
  }

  renderContent(sections){
    this.getSectionsToRender().forEach((section => {
      const elementToReplace =  document.getElementById(section.id);
      elementToReplace.innerHTML =
        this.getSectionInnerHTML(sections[section.section], section.selector);
      
    }));
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerRemoveButton extends HTMLElement {
  constructor() { super(); }
  connectedCallback() {
    this.addEventListener('click', this.handleRemove.bind(this));
  }
  handleRemove(event) {
    event.preventDefault();
    const cartDrawer = this.closest('cart-drawer');
    const bundleContainer = this.closest('[data-bundle-items]');
    if (bundleContainer) {
      const bundleData = bundleContainer.dataset.bundleItems;
      const itemDataElement = bundleContainer.querySelector('.item-data');
      cartDrawer.updateQuantity(
        this.dataset.index,
        0,
        '',
        bundleData,
        'bundle',
        itemDataElement ? itemDataElement.innerText : '{}'
      );
    } else {
      cartDrawer.updateQuantity(this.dataset.index, 0);
    }
  }
}
customElements.define('cart-drawer-remove-button', CartDrawerRemoveButton);

class QuantityInputCart extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
      this.closest('cart-drawer').updateQuantity(this.querySelector('.quantity__input').dataset.index, this.input.value);
  }
}
customElements.define("cus-quantity-input", QuantityInputCart);

class QuantityInputCartGroup extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.groupSize = parseInt(this.input.dataset.groupSize) || 1;
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }
  async onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.currentTarget.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
      const uniqBundleId = this.getAttribute('data-uniq-bundle-id');
      const isBundle = this.getAttribute('data-is-bundle') === 'true';
      const newVisualQty = parseInt(this.input.value) || 0;
      const cartDrawer = this.closest('cart-drawer');
      if (isBundle && uniqBundleId && cartDrawer) {
        try {
          cartDrawer.enableLoading();
          const res = await fetch(window.Shopify.routes.root + 'cart.js');
          const cart = await res.json();
          const updates = {};
          cart.items.forEach(item => {
            if (item.properties && item.properties._uniqBundleId === uniqBundleId) {
              const baseQty = parseInt(item.properties._base_qty) || 1;
              updates[item.key] = baseQty * newVisualQty;
            }
          });
          const updateRes = await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
          const updatedCart = await updateRes.json();
          if (typeof cartDrawer.getSectionsToRender === 'function') {
            cartDrawer.getSectionsToRender().forEach((section) => {
              const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              fetch(`${window.location.pathname}?sections=${section.section}`)
                .then((response) => response.json())
                .then((parsedState) => {
                  elementToReplace.innerHTML = new DOMParser()
                    .parseFromString(parsedState[section.section], 'text/html')
                    .querySelector(section.selector).innerHTML;
                })
                .catch((e) => console.error(e))
                .finally(() => {
                  cartDrawer.disableLoading();
                });
            });
          } else {
            window.location.reload();
          }
        } catch (err) {
          cartDrawer.disableLoading();
        }
      } 
      else {
        const backendQuantity = newVisualQty * this.groupSize;
        const itemIndex = this.input.dataset.index;
        if (cartDrawer && typeof cartDrawer.updateQuantity === 'function') {
          cartDrawer.updateQuantity(itemIndex, backendQuantity);
        }
      }
    }
  }
}
customElements.define("cus-quantity-input-group", QuantityInputCartGroup);

class CartDrawerRemoveButtonGroup extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartDrawer = this.closest('cart-drawer');
      const isBundle = this.getAttribute('data-is-bundle') === 'true';
      const uniqBundleId = this.getAttribute('data-uniq-bundle-id');
      if (isBundle && uniqBundleId && cartDrawer) {
        cartDrawer.enableLoading();
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(res => res.json())
          .then(cart => {
            const updates = {};
            cart.items.forEach(item => {
              if (item.properties && item.properties._uniqBundleId === uniqBundleId) {
                updates[item.key] = 0;
              }
            });
            return fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates })
            });
          })
          .then(res => res.json())
          .then(updatedCart => {
            if (typeof cartDrawer.getSectionsToRender === 'function') {
              cartDrawer.getSectionsToRender().forEach((section) => {
                const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                fetch(`${window.location.pathname}?sections=${section.section}`)
                  .then((response) => response.json())
                  .then((parsedState) => {
                    elementToReplace.innerHTML = new DOMParser()
                      .parseFromString(parsedState[section.section], 'text/html')
                      .querySelector(section.selector).innerHTML;
                  })
                  .catch((e) => console.error(e))
                  .finally(() => {
                    cartDrawer.disableLoading();
                  });
              });
            } else {
              window.location.reload();
            }
          })
          .catch(err => {
            console.error("Bundle remove failed:", err);
            cartDrawer.disableLoading();
          });
      } 
      else {
        const cartItems = this.closest('cart-drawer-items') || this.closest('cart-items');
        if (cartItems && typeof cartItems.updateQuantity === 'function') {
          cartItems.updateQuantity(this.dataset.index, 0);
        } else if (cartDrawer && typeof cartDrawer.updateQuantity === 'function') {
          cartDrawer.updateQuantity(this.dataset.index, 0);
        }
      }
    });
  }
}
customElements.define('cart-drawer-remove-button-group', CartDrawerRemoveButtonGroup);

function removeEntireByobBundle(bundleId, element) {
    if (!bundleId) return;
    if (element) {
        element.style.opacity = '0.5';
        element.style.pointerEvents = 'none';
    }
    let cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.enableLoading === "function") {
        cartDrawer.enableLoading();
    }
    
    fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
        const updates = {};
        cart.items.forEach(item => {
            if (item.properties && item.properties._bundle_id === bundleId) {
                updates[item.key] = 0;
            }
        });
        return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ 
                updates: updates,
                sections: cartDrawer ? cartDrawer.getSectionsToRender().map((s) => s.section) : [],
                sections_url: window.location.pathname
            })
        });
    })
    .then(response => response.json())
    .then(parsedState => {
        if (cartDrawer && parsedState.sections && typeof cartDrawer.renderContent === "function") {
            cartDrawer.renderContent(parsedState.sections);
        } else {
            window.location.reload();
        }
    })
    .catch(err => {
        console.error("BYOB Bundle items remove karne me error:", err);
        window.location.reload();
    })
    .finally(() => {
        if (cartDrawer && typeof cartDrawer.disableLoading === "function") {
            cartDrawer.disableLoading();
        }
    });
}

class UpsellDrawerCart extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.isLoading = false; 
  }
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }
  async handleClick(event) {
    event.preventDefault();
    if (this.isLoading) return;
    try {
      let cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer && typeof cartDrawer.enableLoading === "function") {
          cartDrawer.enableLoading();
      }      
      upsellOptionWant = this;
      this.isLoading = true;

      let fetchUrl = `/pages/global-upsell-drawer`;
      if (this.classList.contains('for___ci___cart__type')) {
          fetchUrl = `/pages/global-upsell-drawer-ci`;
      }

      const response = await fetch(fetchUrl);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const htmlString = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');
      const sectionEl = doc.querySelector('[data-section-type="page-global-upsell"]');
      if (!sectionEl || !sectionEl.dataset.sectionId) return;
      const sectionId = sectionEl.dataset.sectionId;
      const shopifySectionEl = doc.querySelector(`[data-section-id="${sectionId}"]`)?.closest('.shopify-section');
      if (shopifySectionEl) {
        const cartUpsellLoaders = document.querySelector('[js-global-cart-upsell]');
        if (cartUpsellLoaders) {
          requestAnimationFrame(() => {
            cartUpsellLoaders.innerHTML = shopifySectionEl.innerHTML;
            const shippingEl = document.querySelector(`.shipping__progress___behave`);
            const giftEl = document.querySelector(`.gift__progress___behave`);
            const targetAmtEl = document.querySelector(`[js-upsell-shipping-remaining-amt]`);
            const outerContainerEl = document.querySelector(`[js-ct-upsell-shipping-remaining-amt-outer]`);
            if (targetAmtEl) {
              let ShippingRemaining = shippingEl?.dataset?.remainingValue?.trim() || '';
              let GiftRemaining = giftEl?.dataset?.remainingValue?.trim() || '';
              let FilterShippingRemaining = ShippingRemaining ? parseFloat(ShippingRemaining.replace('$', '')) : NaN;
              let FilterGiftRemaining = GiftRemaining ? parseFloat(GiftRemaining.replace('$', '')) : NaN;
              if (!isNaN(FilterShippingRemaining) && FilterShippingRemaining > 0) {
                targetAmtEl.innerHTML = `${ShippingRemaining}`;
                if (outerContainerEl) outerContainerEl.classList.remove('hidden');
              }else if (!isNaN(FilterGiftRemaining) && FilterGiftRemaining > 0) {
                if (outerContainerEl) { 
                  outerContainerEl.classList.remove('hidden');
                  outerContainerEl.innerHTML = `Add another ${GiftRemaining} to get free gift on your order.`; 
                }
              }else { 
                if (outerContainerEl) { 
                  outerContainerEl.classList.add('hidden'); 
                }
              }
              if (!upsellOptionWant?.classList.contains('want__subscription_up')) {
                const upsellItems = cartUpsellLoaders.querySelectorAll('[js-ct-upsell-item-outer]');
                upsellItems.forEach((item) => {
                  const productPrice = item.getAttribute('data-product-price') || item.dataset.productPrice;
                  if (productPrice) {
                    const priceTarget = item.querySelector('[js-ct-upsell-product-price]');
                    if (priceTarget) {
                      priceTarget.innerHTML = productPrice.trim();
                      priceTarget.classList.add('normal__price__color');
                    }
                    const comparePriceTarget = item.querySelector('[js-ct-upsell-product-cprice]');
                    if (comparePriceTarget) {
                      comparePriceTarget.innerHTML = '';
                      comparePriceTarget.classList.add('hidden');
                    }
                  }
                });
              }
            }
          });
        }
      } else {
        console.warn(`HTML EMPTY FOR UPSELL`);
      }
    } catch (err) {
      console.error("Drawer fetch error:", err);
    } finally {
      this.isLoading = false;      
      document.querySelector('[js-global-cart-upsell]').classList.add('active');
      let cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer && typeof cartDrawer.disableLoading === "function") {
          cartDrawer.disableLoading();
      }      
    }
  }
}

if (!customElements.get('cus-upsell-recommendations')) {
  customElements.define('cus-upsell-recommendations', UpsellDrawerCart);
}

document.addEventListener('click', (event) => {
  const backButton = event.target.closest('[js-ct-upsell-back-process]');
  if (backButton) {
    const cartUpsellLoaders = document.querySelector('[js-global-cart-upsell]');
    if (cartUpsellLoaders) { cartUpsellLoaders.innerHTML = ''; cartUpsellLoaders.classList.remove('active');}
  }

  const addButton = event.target.closest('[js-ct-upsell-confiq-add]');
  if (addButton) {
      event.preventDefault();
      const mainItemOuter = addButton.closest('[js-ct-upsell-item-outer]');
      const configOuter = addButton.closest('[js-ct-upsell-confiq-outer]');
      if (mainItemOuter && configOuter) {
          configOuter.classList.add('active');
          mainItemOuter.classList.add('active');
      }
      return;
  }

  const removeButton = event.target.closest('[js-ct-upsell-confiq-remove]');
  if (removeButton) {
      event.preventDefault();
      const mainItemOuter = removeButton.closest('[js-ct-upsell-item-outer]');
      const configOuter = removeButton.closest('[js-ct-upsell-confiq-outer]');
      if (mainItemOuter && configOuter) {
          configOuter.classList.remove('active');
          mainItemOuter.classList.remove('active');
      }
      return;
  }

  const plusButton = event.target.closest('[js-ct-upsell-confiq-plus]');
  if (plusButton) {
      event.preventDefault();
      const mainItemOuter = plusButton.closest('[js-ct-upsell-item-outer]');
      const qtyContainer = plusButton.closest('[js-ct-upsell-confiq-qty]');
      if (mainItemOuter && qtyContainer) {
          const inputElm = qtyContainer.querySelector('[js-ct-upsell-confiq-input]');
          let currentQty = parseInt(inputElm.textContent || "1", 10);
          currentQty = currentQty + 1;
          inputElm.innerHTML = currentQty;
          if (currentQty > 1) {
              qtyContainer.querySelector('[js-ct-upsell-confiq-remove]')?.classList.add('hidden');
              qtyContainer.querySelector('[js-ct-upsell-confiq-minus]')?.classList.remove('hidden');
          }
      }
      return;
  }

  const minusButton = event.target.closest('[js-ct-upsell-confiq-minus]');
  if (minusButton) {
      event.preventDefault();
      const mainItemOuter = minusButton.closest('[js-ct-upsell-item-outer]');
      const qtyContainer = minusButton.closest('[js-ct-upsell-confiq-qty]');
      if (mainItemOuter && qtyContainer) {
          const inputElm = qtyContainer.querySelector('[js-ct-upsell-confiq-input]');
          let currentQty = parseInt(inputElm.textContent || "1", 10);
          currentQty = currentQty - 1;
          inputElm.innerHTML = currentQty;
          if (currentQty === 1) {
              qtyContainer.querySelector('[js-ct-upsell-confiq-remove]')?.classList.remove('hidden');
              qtyContainer.querySelector('[js-ct-upsell-confiq-minus]')?.classList.add('hidden');
          }
      }
      return;
  }

  const WantSubmitButtonUps = event.target.closest('[js-ct-upsell-takeover-submit]');
  if (WantSubmitButtonUps) {
      event.preventDefault();
      let cartElement = document.querySelector("cart-drawer");
      if (cartElement) cartElement.enableLoading();  
      const submitButton = WantSubmitButtonUps;    
      const container = document.querySelector(`.items__globally__upsell___blocks`);
      if (!container) return;
      const mappedElements = container.querySelector(`.product_route_recommendations_items`)?.querySelectorAll(`[data-product-variant-id].active`);
      if (!mappedElements || mappedElements.length === 0) {
          if (cartElement) cartElement.disableLoading();
          return;
      }
      const isSubscription = typeof upsellOptionWant !== 'undefined' && upsellOptionWant?.classList.contains('want__subscription_up');
      const items = [];
      submitButton.classList.add('loading');
      submitButton.disabled = true;

      if (!window.upsellIdMap) {
          window.upsellIdMap = {};
          window.upsellBoxIndexCounter = 0;
      }

      fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
      .then(res => res.json())
      .then(currentCart => {

          const primaryItems = (currentCart?.items || []).filter(cartItem => {
              return !(cartItem.properties && cartItem.properties._is_byob_child);
          });

          const cheapestPrimary = primaryItems.length > 0
              ? primaryItems.reduce((cheapest, item) =>
                  item.final_line_price < cheapest.final_line_price ? item : cheapest
              , primaryItems[0])
              : null;

          const cheapestWithBox = cheapestPrimary?.properties?._dynamicBoxId
              ? cheapestPrimary
              : primaryItems.find(item => item.properties?._dynamicBoxId) || cheapestPrimary;

          mappedElements.forEach((item) => {
              const variantId    = item.dataset.productVariantId;
              const sellingId    = item.dataset.productSellingId;
              const dynamicBoxID = item.dataset.productDynamicboxId;
              const quantityMap  = parseInt(item.querySelector(`[js-ct-upsell-confiq-input]`)?.textContent);
              const servingInCart = item.querySelector(`.rc____item__content__serving`)?.textContent?.trim() || '';
              if (!variantId) return;

              let dynamicBoxIndex = 0;
              let existingChildProperties = {};
              let matchingChild = null;

              const trimmedDynamicBoxID = dynamicBoxID?.toString().trim() || '';
              const matchingPrimary = primaryItems.find(cartItem =>
                  cartItem.properties?._dynamicBoxId === trimmedDynamicBoxID
              );
              const activePrimary = matchingPrimary || cheapestWithBox;

              if (trimmedDynamicBoxID !== '') {
                  if (currentCart && currentCart.items) {
                      matchingChild = currentCart.items.find(cartItem => {
                          const hasProperties = cartItem.properties;
                          const isChild = hasProperties && cartItem.properties._is_byob_child;
                          const isIdMatch = hasProperties && cartItem.properties._dynamicBoxId === trimmedDynamicBoxID;
                          if (isChild && isIdMatch) {
                              const cartItemIsOnetime = cartItem.properties._is_onetime === 'true' || cartItem.properties._is_onetime === true;
                              if (isSubscription) {
                                  return !cartItemIsOnetime;
                              } else {
                                  return cartItemIsOnetime;
                              }
                          }
                          return false;
                      });

                      if (matchingChild && matchingChild.properties) {
                          existingChildProperties = { ...matchingChild.properties };
                          if (matchingChild.properties._dynamicBoxIndex !== undefined) {
                              dynamicBoxIndex = matchingChild.properties._dynamicBoxIndex;
                          }
                      } else {
                          if (activePrimary && activePrimary.properties?._dynamicBoxId) {
                              existingChildProperties._dynamicBoxId    = activePrimary.properties._dynamicBoxId;
                              existingChildProperties._dynamicBoxIndex = activePrimary.properties._dynamicBoxIndex || 0;
                              dynamicBoxIndex = existingChildProperties._dynamicBoxIndex;
                          } else {
                              if (window.upsellIdMap[trimmedDynamicBoxID] === undefined) {
                                  window.upsellIdMap[trimmedDynamicBoxID] = window.upsellBoxIndexCounter;
                                  window.upsellBoxIndexCounter++;
                              }
                              dynamicBoxIndex = window.upsellIdMap[trimmedDynamicBoxID];
                          }
                      }
                  }
              } else {
                  if (activePrimary && activePrimary.properties?._dynamicBoxId) {
                      existingChildProperties._dynamicBoxId    = activePrimary.properties._dynamicBoxId;
                      existingChildProperties._dynamicBoxIndex = activePrimary.properties._dynamicBoxIndex || 0;
                      dynamicBoxIndex = existingChildProperties._dynamicBoxIndex;
                  }
              }

              const cartItem = {
                  id: parseInt(variantId, 10),
                  quantity: quantityMap,
                  properties: { ...existingChildProperties }
              };

              if (isSubscription) {
                  if (!matchingChild) {
                      if (activePrimary && activePrimary.properties?._dynamicBoxId) {
                          if (sellingId && sellingId.trim() !== '') {
                              cartItem.selling_plan = activePrimary.selling_plan_allocation?.selling_plan?.id;
                          }
                          cartItem.properties._dynamicBoxId    = activePrimary.properties._dynamicBoxId;
                          cartItem.properties._dynamicBoxIndex = activePrimary.properties._dynamicBoxIndex || 0;
                          cartItem.properties._serving_txt     = servingInCart;
                      } else {
                          if (sellingId && sellingId.trim() !== '') {
                              cartItem.selling_plan = parseInt(sellingId, 10);
                          }
                          if (trimmedDynamicBoxID !== '') {
                              cartItem.properties._dynamicBoxId    = dynamicBoxID;
                              cartItem.properties._dynamicBoxIndex = 0;
                              cartItem.properties._serving_txt     = servingInCart;
                          }
                      }
                  } else {
                      if (sellingId && sellingId.trim() !== '') {
                          cartItem.selling_plan = parseInt(sellingId, 10);
                      }
                      if (trimmedDynamicBoxID !== '') {
                          cartItem.properties._dynamicBoxId    = dynamicBoxID;
                          cartItem.properties._dynamicBoxIndex = dynamicBoxIndex;
                          cartItem.properties._serving_txt     = servingInCart;
                      }
                  }
              } else {
                  if (!matchingChild) {
                      if (activePrimary && activePrimary.properties?._dynamicBoxId) {
                          cartItem.properties._dynamicBoxId    = activePrimary.properties._dynamicBoxId;
                          cartItem.properties._dynamicBoxIndex = activePrimary.properties._dynamicBoxIndex || 0;
                          cartItem.properties._serving_txt     = servingInCart;
                          if (sellingId && sellingId.trim() !== '') {
                              cartItem.properties._selling_plan_id = activePrimary.selling_plan_allocation?.selling_plan?.id?.toString() || '';
                          }
                      } else {
                          if (trimmedDynamicBoxID !== '') {
                              cartItem.properties._dynamicBoxId    = dynamicBoxID;
                              cartItem.properties._dynamicBoxIndex = 0;
                              cartItem.properties._serving_txt     = servingInCart;
                              cartItem.properties._selling_plan_id = sellingId || '';
                          }
                      }
                  } else {
                      if (trimmedDynamicBoxID !== '') {
                          cartItem.properties._dynamicBoxId    = dynamicBoxID;
                          cartItem.properties._dynamicBoxIndex = dynamicBoxIndex;
                          cartItem.properties._serving_txt     = servingInCart;
                          cartItem.properties._selling_plan_id = sellingId || '';
                      }
                  }
              }

              items.push(cartItem);
          });   
          
          const productShouldBe = { items: items };

          if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
              productShouldBe.sections = cartElement.getSectionsToRender().map((section) => section.section);
              productShouldBe.sections_url = window.location.pathname;
          }

          return fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(productShouldBe)
          });
      })
      .then((response) => {
          if (!response.ok) {
              return response.text().then(text => { throw new Error(text) });
          }
          return response.json();
      })
      .then((parsedState) => {
          if (cartElement && parsedState.sections) {
              cartElement.renderContent(parsedState.sections);
          } else if (cartElement && typeof cartElement.updateQuantity === 'function') {
              cartElement.classList.remove('is-empty');
          }
      })
      .catch((e) => {
          console.error("Shopify Cart Add Error Details:", e);
      })
      .finally(() => {
          if (cartElement) { 
              cartElement.disableLoading(); 
          }
          submitButton.classList.remove('loading');
          submitButton.disabled = false;
          
          const cartUpsellLoadersInit = document.querySelector('[js-global-cart-upsell]');
          if (cartUpsellLoadersInit) { 
              cartUpsellLoadersInit.innerHTML = ''; 
              cartUpsellLoadersInit.classList.remove('active');
          }          
      });      
  }

});

class OrderProtectionPopup extends HTMLElement {
  constructor() {
    super();
    this.openWidget = this.openWidget.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.portalInstance = null;
  }

  connectedCallback() {
    this.widgetTrigger = this.querySelector('[js-order-protection-widget]');
    if (this.widgetTrigger) {
      this.widgetTrigger.addEventListener('click', this.openWidget);
    }
  }

  disconnectedCallback() {
    if (this.widgetTrigger) {
      this.widgetTrigger.removeEventListener('click', this.openWidget);
    }
    this.cleanupModal();
  }

  getModalHtml() {
    return `
      <div class="op_modal_portal">
        <div class="op_modal_overlay" js-op-modal-close></div>
        <div class="op_modal_content">
          <div class="op_modal_container" role="dialog" aria-modal="true" aria-labelledby="op_information_modal_title">
            <div class="op_modal_header">
              <img class="op_modal_logo" src="https://cdn.shopify.com/s/files/1/0267/3351/0727/files/OPLogoPurple2.svg?v=1782300969" alt="Order Protection Logo">
              <button class="op_modal_close_button" aria-label="Close Info Modal" js-op-modal-close>
                <img src="https://cdn.shopify.com/s/files/1/0267/3351/0727/files/close-icon.svg?v=1782300968" alt="Close Info Modal">
              </button>
            </div>

            <div class="op_modal_headings">
              <div class="op_modal_subheading">Shipping Issues are over</div>
              <h2 id="op_information_modal_title" class="op_modal_heading">Get shipping protection &amp; 24/7 support.</h2>
              <hr class="op_modal_divider">
            </div>

            <div class="op_steps">
              <div class="op_step">
                <div class="op_step_image_wrap">
                  <img class="op_step_image" src="https://cdn.shopify.com/s/files/1/0267/3351/0727/files/CartPurple2.svg?v=1782300969" alt="" aria-hidden="true">
                </div>
                <div class="op_step_content">
                  <div class="op_step_title">Add shipping protection to your order.</div>
                </div>
              </div>

              <div class="op_step">
                <div class="op_step_image_wrap">
                  <img class="op_step_image" src="https://cdn.shopify.com/s/files/1/0267/3351/0727/files/StatusWarningPurple2.svg?v=1782300969" alt="" aria-hidden="true">
                </div>
                <div class="op_step_content">
                  <div class="op_step_title">Have a shipping issue? Let us know.</div>
                  <ul class="op_step_checklist">
                    <li>
                      <img class="op_step_check_icon" src="https://cdn.shopify.com/s/files/1/0267/3351/0727/files/check_d6c2c41d-9202-49d6-ac49-c055d20bb519.svg?v=1782301520" alt="" aria-hidden="true">
                      <span>Theft</span>
                    </li>
                    <li>
                      <img class="op_step_check_icon" src="https://cdn.shopify.com/s/files/1/0267/3351/0727/files/check_d6c2c41d-9202-49d6-ac49-c055d20bb519.svg?v=1782301520" alt="" aria-hidden="true">
                      <span>Damaged items</span>
                    </li>
                    <li>
                      <img class="op_step_check_icon" src="https://cdn.shopify.com/s/files/1/0267/3351/0727/files/check_d6c2c41d-9202-49d6-ac49-c055d20bb519.svg?v=1782301520" alt="" aria-hidden="true">
                      <span>Missing items</span>
                    </li>
                    <li>
                      <img class="op_step_check_icon" src="https://cdn.shopify.com/s/files/1/0267/3351/0727/files/check_d6c2c41d-9202-49d6-ac49-c055d20bb519.svg?v=1782301520" alt="" aria-hidden="true">
                      <span>Lost packages</span>
                    </li>
                    <li>
                      <img class="op_step_check_icon" src="https://cdn.shopify.com/s/files/1/0267/3351/0727/files/check_d6c2c41d-9202-49d6-ac49-c055d20bb519.svg?v=1782301520" alt="" aria-hidden="true">
                      <span>Wrong items</span>
                    </li>
                    <li>
                      <img class="op_step_check_icon" src="https://cdn.shopify.com/s/files/1/0267/3351/0727/files/check_d6c2c41d-9202-49d6-ac49-c055d20bb519.svg?v=1782301520" alt="" aria-hidden="true">
                      <span>Returned to sender</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="op_step">
                <div class="op_step_image_wrap">
                  <img class="op_step_image" src="https://cdn.shopify.com/s/files/1/0267/3351/0727/files/PackageArrivedPurple2.svg?v=1782301615" alt="" aria-hidden="true">
                </div>
                <div class="op_step_content">
                  <div class="op_step_title">Get a resolution in as little as one hour. *</div>
                </div>
              </div>
            </div>

            <div class="op_modal_footer">
              <p>* Contingent upon claim approval. In some cases, additional time may be required for investigation.</p>
              <p class="op_modal_footer_links">
                <span>${new Date().getFullYear()} © OrderProtection.com</span>
                <a href="https://orderprotection.com/legal/customer-terms-conditions" target="_blank" rel="noopener noreferrer">Terms</a>
                <a href="https://orderprotection.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                <a href="https://claims.justaddbuoy.com/" target="_blank" rel="noopener noreferrer">File a Claim</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  openWidget(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (document.querySelector('.op_modal_portal')) return;

    const tempDiv = document.createElement('div'); 
    tempDiv.innerHTML = this.getModalHtml().trim();
    this.portalInstance = tempDiv.firstChild;

    document.body.appendChild(this.portalInstance);

    document.documentElement.style.setProperty('--op-scroll-top', `${window.scrollY}px`);
    document.body.classList.add('overflow-hidden');

    this.portalInstance.querySelectorAll('[js-op-modal-close]').forEach(closeBtn => {
      closeBtn.addEventListener('click', this.closeModal);
    });
    document.addEventListener('keydown', this.handleKeyDown);

    requestAnimationFrame(() => {
      const overlay = this.portalInstance.querySelector('.op_modal_overlay');
      const container = this.portalInstance.querySelector('.op_modal_container');
    });
  } 

  closeModal(event) { 
    if (event) event.preventDefault();
    this.cleanupModal();
  }

  handleKeyDown(event) {
    if (event.key === 'Escape') {
      this.cleanupModal();
    }
  }

  cleanupModal() {
    if (!this.portalInstance) return;
    document.removeEventListener('keydown', this.handleKeyDown);
    this.portalInstance.querySelectorAll('[js-op-modal-close]').forEach(closeBtn => {
      closeBtn.removeEventListener('click', this.closeModal);
    });
    setTimeout(() => { 
      if (this.portalInstance && this.portalInstance.parentNode) { 
        this.portalInstance.parentNode.removeChild(this.portalInstance);
      }
      this.portalInstance = null;
      document.body.classList.remove('overflow-hidden'); 
    }, 300);
  }
}  

if (!customElements.get('order-protection-popup')) {
  customElements.define('order-protection-popup', OrderProtectionPopup);
}

class CusPromoWidget extends HTMLElement {
  connectedCallback() { 
    this.header = this.querySelector('[js-promo-code-fsb-header]');
    this.widgetBody = this.querySelector('[js-promo-code-fsb-widget]');
    this.inputField = this.querySelector('[js-promo-code-fsb-input]');
    this.shouldReturn = this.querySelector('[js-promo-code-fsb-return]');
    this.clearBtn = this.querySelector('[js-promo-code-fsb-icon]');
    this.removeBtn = this.querySelector('[js-promo-code-fsb-remove]');
 
    const pendingError = sessionStorage.getItem('promo_error_value');
    if (pendingError) {
      if (this.widgetBody) this.widgetBody.classList.remove('hidden');
      if (this.header) this.header.classList.add('hidden');
      if (this.inputField) this.inputField.value = pendingError;
      this.ErrorsEvent();
      sessionStorage.removeItem('promo_error_value');
    }
 
    this.initEvents();
  }

  clearFieldsEvent() {
    this.shouldReturn.textContent = ``;
    this.clearBtn.classList.remove(`succeed___applied`);
    this.clearBtn.classList.remove(`succeed___submit`);
    this.widgetBody.classList.remove('should___error');
    this.widgetBody.classList.remove('should___success');
    this.clearBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"> <path d="M7.01257 7.99926L1.84943 2.83612L2.83686 1.84869L8 7.01183L13.1631 1.84869L14.1506 2.83612L8.98743 7.99926L14.1506 13.1624L13.1631 14.1498L8 8.98668L2.83686 14.1498L1.84943 13.1624L7.01257 7.99926Z" fill="#797B7A"></path> </svg>`;
  }

  makeButtonChange() {
    this.clearBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none" transform="rotate(-90)"><path d="M8.5 12.58 1 5.081 2.082 4 8.5 10.438l6.418-6.418L16 5.102z" fill="#797b7a"/></svg>`;
  }

  ErrorsEvent() {
    this.widgetBody.classList.add('should___error');
    this.shouldReturn.textContent = `Invalid code`;
    this.clearBtn.classList.remove(`succeed___submit`);
    this.clearBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"> <path d="M7.9994 14.7864C7.15195 14.7864 6.3577 14.6282 5.61665 14.3118C4.87558 13.9954 4.22786 13.5603 3.67348 13.0065C3.11909 12.4527 2.684 11.806 2.36821 11.0663C2.05243 10.3266 1.89453 9.53209 1.89453 8.68283H3.03005C3.03005 10.0637 3.513 11.2363 4.4789 12.2005C5.4448 13.1648 6.61765 13.6469 7.99745 13.6469C9.37615 13.6469 10.5483 13.1643 11.5139 12.1991C12.4795 11.2338 12.9623 10.0617 12.9623 8.68283C12.9623 7.30194 12.4937 6.12936 11.5564 5.16509C10.6191 4.20082 9.4595 3.71869 8.07752 3.71869H7.69418L8.88693 4.91144L8.16773 5.64332L5.642 3.11361L8.16773 0.587891L8.88693 1.30709L7.61085 2.57919H7.99418C8.84299 2.57919 9.63804 2.7374 10.3793 3.05382C11.1206 3.37026 11.7682 3.80535 12.3219 4.35909C12.8756 4.91284 13.3107 5.55979 13.6271 6.29994C13.9436 7.04011 14.1018 7.83395 14.1018 8.68148C14.1018 9.52899 13.9439 10.3231 13.628 11.0639C13.3122 11.8047 12.877 12.4524 12.3226 13.0069C11.7681 13.5615 11.1208 13.9967 10.3807 14.3126C9.64062 14.6285 8.84684 14.7864 7.9994 14.7864Z" fill="#1F2322"/> </svg>`;
  }

  initRemoveBtn() {
    if (!this.removeBtn) return;
    this.removeBtn.addEventListener('click', async (e) => {
      e.stopPropagation();
      this.removeBtn.disabled = true;
      this.removeBtn.innerHTML = `<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"> <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle> </svg>`;
      try {
        const cartDrawerElement = document.querySelector('cart-drawer');
        const updateData = { discount: '' };
        if (cartDrawerElement && typeof cartDrawerElement.getSectionsToRender === 'function') {
          updateData.sections = cartDrawerElement.getSectionsToRender().map((s) => s.section);
          updateData.sections_url = window.location.pathname;
        }
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(updateData)
        });
        if (!response.ok) throw new Error(await response.text());
        const parsedState = await response.json();
        if (cartDrawerElement && parsedState.sections) {
          cartDrawerElement.renderContent(parsedState.sections);
        } else {
          window.location.reload();
        }
      } catch (error) {
        console.error('Remove promo failed:', error);
        if (this.removeBtn) {
          this.removeBtn.disabled = false;
          this.removeBtn.textContent = 'Remove';
        }
      }
    });
  }

  async submitPromoCode() {
    const FilledPromoCode = this.inputField.value.trim();

    if (FilledPromoCode === '') {
      this.ErrorsEvent();
      return;
    }

    const cartDrawerElement = document.querySelector('cart-drawer');
    this.shouldReturn.textContent = ``;
    this.widgetBody.classList.remove('should___error');
    this.widgetBody.classList.remove('should___success');
    this.clearBtn.classList.remove(`succeed___submit`);
    this.clearBtn.innerHTML = `<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"> <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle> </svg>`;

    try {
      const updateData = { discount: FilledPromoCode };
      if (cartDrawerElement && typeof cartDrawerElement.getSectionsToRender === 'function') {
        updateData.sections = cartDrawerElement.getSectionsToRender().map((section) => section.section);
        updateData.sections_url = window.location.pathname;
      }

      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(updateData)
      });

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text);
      }

      const parsedState = await response.json();
      let isCurrentCodeApplied = false;
      if (parsedState.discount_codes && parsedState.discount_codes.length > 0) {
        isCurrentCodeApplied = parsedState.discount_codes.some(
          item => item.code.toUpperCase() === FilledPromoCode.toUpperCase() && item.applicable === true
        );
      }

      const dynamicDiscountElement = this.widgetBody.classList.contains('applied__discount__recent');

      if (isCurrentCodeApplied) {
        if (cartDrawerElement && parsedState.sections) {
          cartDrawerElement.renderContent(parsedState.sections);
        }
        this.widgetBody.classList.add('should___success');
        this.clearBtn.classList.add('succeed___applied');
        this.clearBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 10.5L3.5 8L2.08 9.41L6 13.33L14 5.33L12.59 3.92L6 10.5Z" fill="#1F2322"/></svg>`;

        const outerSpan = this.querySelector('[js-promo-code-fsb-outer]');
        if (outerSpan && !outerSpan.querySelector('[js-promo-code-fsb-remove]')) {
          const removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.className = 'code___fsb__remove__btn';
          removeBtn.setAttribute('js-promo-code-fsb-remove', '');
          removeBtn.textContent = 'Remove';
          outerSpan.insertBefore(removeBtn, this.clearBtn);
          this.removeBtn = removeBtn;
          this.initRemoveBtn();
        }
      } else {
        if (dynamicDiscountElement) {
          sessionStorage.setItem('promo_error_value', FilledPromoCode);
          if (cartDrawerElement && parsedState.sections) {
            cartDrawerElement.renderContent(parsedState.sections);
          }
        } else {
          this.ErrorsEvent();
        }
      }
    } catch (error) {
      console.error("Promo code not working:", error);
      this.ErrorsEvent();
    }
  }

  initEvents() {
    if (this.header && this.widgetBody) {
      this.header.addEventListener('click', () => {
        const isHidden = this.widgetBody.classList.contains('hidden');
        this.widgetBody.classList.toggle(`hidden`);
        this.header.classList.toggle('hidden', isHidden);
      });
    }

    if (this.clearBtn && this.inputField) {
      this.clearBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (this.clearBtn.classList.contains(`succeed___applied`)) {
          return;
        } else if (this.clearBtn.classList.contains(`succeed___submit`)) {
          this.submitPromoCode();
        } else if (this.inputField.value.trim() !== '') {
          this.inputField.value = '';
          this.inputField.focus();
          if (typeof this.clearFieldsEvent === 'function') { this.clearFieldsEvent(); }
        } else {
          if (this.widgetBody) { this.widgetBody.classList.add('hidden'); }
          if (this.header) { this.header.classList.remove('hidden'); }
        }
      });
    }

    if (this.inputField) {
      this.inputField.addEventListener('input', (e) => {
        this.clearFieldsEvent();
        if (e.target.value.trim() !== '') {
          this.clearBtn.classList.add(`succeed___submit`);
          this.makeButtonChange();
        }
      });

      this.inputField.addEventListener('keydown', async (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.submitPromoCode();
        }
      });
    }
    this.initRemoveBtn();
  }
}

if (!customElements.get('cus-promo-widget')) { customElements.define('cus-promo-widget', CusPromoWidget); }